<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Editar Tipo Veículo</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div [formGroup]="form" class="flex justify-between gap-4 items-center mt-3">
    <mat-form-field
      class="input-tg mt-message-input w-2/4"
      appearance="outline"
    >
      <mat-label>Código</mat-label>
      <input matInput formControlName="code" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-2/4"
      appearance="outline"
    >
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-1/5"
      [disabled]="form.invalid || loading"
      (click)="updateItem()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Salvar
      }
    </button>
  </div>
</mat-card>
